import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setBet } from "../../../../redux/coinPrices/actions";
import "./styles.scss";
import { useTheme } from "../../../../hook/useThemes";
import { formatCoin, formatNumberForOdds } from "../../../../utils/utils";
import ModalSelectBet from "../ButtonBet/ModalSelectBet";

function ButtonBetMin() {
  const dispatch = useDispatch();
  const valueBet = useSelector((state: any) => state?.coinPrices?.bet || 0);

  const { lang } = useTheme();
  const [open, setOpen] = useState<boolean>(false);

  const handleSetBet = (value: any) => {
    if (value && value !== "0") {
      dispatch<any>(setBet(value));
    }
  };

  return (
    <>
      <button
        className="button-bet"
        onClick={() => {
          setOpen(true);
        }}
      >
        {lang?.stake || "Stake"} ${formatNumberForOdds(valueBet, true)}
      </button>

      <ModalSelectBet
        valueBetDefault={valueBet}
        open={open}
        onClose={() => setOpen(false)}
        onConfirm={handleSetBet}
      />
    </>
  );
}

export default ButtonBetMin;
